class LowFi extends Phaser.Group {
  constructor({ game }) {
    super(game);
    this.maskp = this.game.add.graphics();
    this.maskp.beginFill(0xffffff, 1);
    this.maskp.drawRect(0, 0, this.game.width, this.game.height);
    this.maskp.endFill();
    this.maskp.anchor.set(0.5);
    this.maskp.position.set(0, 0);
    this.maskp.alpha = 0;
    this.addChild(this.maskp);

    this.onInComplete = new Phaser.Signal();
    this.onOutComplete = new Phaser.Signal();
  }

  init() {}

  startIn() {
    const fade = this.game.add.tween(this.maskp).to({ alpha: 1 }, 200, 'Cubic.easeInOut', false);
    fade.onComplete.addOnce(this.startInComplete, this);
    fade.start();
  }

  startInComplete() {
    this.onInComplete.dispatch(this);
  }

  startOut() {
    const fade = this.game.add.tween(this.maskp).to({ alpha: 0 }, 200, 'Cubic.easeInOut', false);
    fade.onComplete.addOnce(this.startOutComplete, this);
    fade.start();
  }

  startOutComplete() {
    this.onOutComplete.dispatch(this);
  }

  destroy(destroyChildren = true, soft) {
    this.onInComplete.forget();
    this.onInComplete.dispose();
    this.onInComplete.removeAll();

    this.onOutComplete.forget();
    this.onOutComplete.dispose();
    this.onOutComplete.removeAll();

    this.maskp = null;
    super.destroy(destroyChildren);
  }
}
export default LowFi;
